import { formatDate, formatString } from "@/shared/formats";
import { RegistroAuditoria } from "@/shared/types/registro-auditoria";
import { Stack, Typography } from "@mui/material";
import { ReactNode } from "react";
import { renderClavePrimaria, renderTipoAccion } from "../shared/utils";


export default function RegistroAuditoriaView({ registro }: { registro: RegistroAuditoria }) {
    return <Stack padding={3} gap={2}>
        <SubtitleDataPair title={"Fecha"} value={formatDate(registro.fecha, true)} />
        <SubtitleDataPair title={"Nombre de Tabla"} value={formatString(registro.nombreTabla)} />
        <SubtitleDataPair title={"Nombre de Usuario"} value={formatString(registro.nombreUsuario)} />
        <SubtitleDataPair title={"Tipo de Acción"} value={formatString(renderTipoAccion(registro.tipoAuditoria))} />
        <SubtitleDataPair title={"ID de la Entrada"} value={formatString(renderClavePrimaria(registro.clavePrimaria))} />
        <SubtitleDataPair title={"Columnas Afectadas"} />
        <ArrayDisplay array={registro.columnasAfectadas} />
        <SubtitleDataPair title={"Valores Anteriores"} />
        <ObjectDisplay object={registro.valoresAnteriores} />
        <SubtitleDataPair title={"Valores Nuevos"} />
        <ObjectDisplay object={registro.valoresNuevos} />
    </Stack>
}

function SubtitleDataPair({
    title,
    value
}: {
    title?: ReactNode,
    value?: ReactNode
}) {
    return <Stack direction={"row"} alignItems={"start"} gap={1}>
        <Typography variant="subtitle2" component={"h2"}>{title}{value ? ":" : ""}</Typography>
        <Typography variant="body2" sx={{ overflowWrap: "break-word", overflowX: "hidden" }}>{value}</Typography>
    </Stack>
}

function ObjectDisplay({
    object
}: { object: any }) {
    if (!object || Object.keys(object).length <= 0) return <Stack marginLeft={3}>---</Stack>

    return <Stack marginLeft={3}>{
        Object.entries(object).map(([key, value]) => <Stack key={key} direction={"row"} gap={1}>
            <Typography variant="body2">{String(key)}: </Typography>
            <Typography variant="body2" sx={{ overflowWrap: "break-word", overflowX: "hidden" }}>{formatString(value)}</Typography>
        </Stack>)
    }</Stack>
}

function ArrayDisplay({
    array
}: { array: any[] }) {
    return <Stack marginLeft={3}>
        <Typography variant="body2">{formatString(array.join(", "))}</Typography>
    </Stack>
}
